'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.72989e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.000175947 6.66667 2.72989e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M20 0H28V20H20V0Z", fill: "#FF3131" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H8V0H2.72989e-05L0 20Z",
          fill: "#FF3131"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.1118 9.22153C15.8786 9.45473 15.4846 9.24385 15.5492 8.92045L16 6.66667L14.6667 7.33333L14 5.33333L13.3333 7.33333L12 6.66667L12.4508 8.92045C12.5154 9.24385 12.1214 9.45473 11.8882 9.22153L11.569 8.90237C11.4389 8.77219 11.2278 8.77219 11.0976 8.90237L10.6667 9.33333L9.33333 8.66667L10 10L9.56903 10.431C9.43886 10.5611 9.43886 10.7722 9.56904 10.9024L11.3333 12.6667H13.3333L13.6667 14.6667H14.3333L14.6667 12.6667H16.6667L18.431 10.9024C18.5611 10.7722 18.5611 10.5611 18.431 10.431L18 10L18.6667 8.66667L17.3333 9.33333L16.9024 8.90237C16.7722 8.77219 16.5611 8.77219 16.431 8.90237L16.1118 9.22153Z",
          fill: "#FF3131"
        }
      )
    ]
  }
);
const VpFlagCaAsset = forwardRef(FlagCaAsset);

export { VpFlagCaAsset as default };
